export default "__VITE_ASSET__BPpxIcKU__"